import { useState } from 'react';
import { useAuditoria } from '../../api/embarques';
import { ErrorState, LoadingBlock } from '../../components/states';
import { formatDateTime } from '../../format';
import { t } from '../../i18n/pt-BR';

const s = t.shipments;
const a = s.auditColumns;

/** Auditoria por campo: admin vê tudo; Importação vê só o que o próprio perfil alterou. */
export function AuditoriaPage() {
  const [chave, setChave] = useState('');
  const dados = useAuditoria({ chave: chave.trim() || undefined });
  return (
    <section className="panel" aria-labelledby="aud-title">
      <h2 id="aud-title">{s.auditTitle}</h2>
      <p className="hint">{s.auditHint}</p>
      <div className="row">
        <label className="inline-label" htmlFor="aud-chave">
          {a.key}
        </label>
        <input id="aud-chave" className="select" value={chave} onChange={(e) => setChave(e.target.value)} />
      </div>
      {dados.isLoading ? (
        <LoadingBlock rows={4} />
      ) : dados.isError ? (
        <ErrorState error={dados.error} onRetry={() => void dados.refetch()} />
      ) : (
        <div className="scroll" style={{ marginTop: 12 }}>
          <table className="cad-table">
            <thead>
              <tr>
                <th>{a.when}</th>
                <th>{a.user}</th>
                <th>{a.profile}</th>
                <th>{a.resource}</th>
                <th>{a.key}</th>
                <th>{a.action}</th>
                <th>{a.field}</th>
                <th>{a.before}</th>
                <th>{a.after}</th>
              </tr>
            </thead>
            <tbody>
              {(dados.data ?? []).map((r) => (
                <tr key={r.id}>
                  <td>{formatDateTime(r['dt-hora'])}</td>
                  <td>{r.usuario ?? '—'}</td>
                  <td>{r.perfil ?? '—'}</td>
                  <td>{r.recurso}</td>
                  <td>{r.chave ?? '—'}</td>
                  <td>{r.acao}</td>
                  <td>{r.campo ?? '—'}</td>
                  <td>{r['valor-anterior'] ?? '—'}</td>
                  <td>{r['valor-novo'] ?? '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
